import { Tab } from '@headlessui/react'
import React from 'react'

import { useClass } from '@/hooks/useClass'

type TabButtonProps = {
  children: React.ReactNode
  className?: string
}

export const TabButton = ({ children, className }: TabButtonProps) => {
  const buttonClass = useClass('w-[86px] pb-[6px]', className)

  return (
    <Tab as={React.Fragment}>
      {({ selected }) => (
        <button
          className={
            selected
              ? `text-[#FF9137] border-b-2 border-interactive-to ${buttonClass}`
              : `text-unselected ${buttonClass}`
          }
        >
          {children}
        </button>
      )}
    </Tab>
  )
}
